import { IFormViewForm } from 'components/FormView';

const AddWidgetForm: IFormViewForm = {
    id: 'AddWidgetForm',
    layout: {
        rows: 1,
        columns: 1
    },
    fields: [
        {
            id: '1',
            position: {
                row: 1,
                col: 1,
                colspan: 3
            },
            type: 'PAPER_CONTAINER',
            props: {
                elevation: 0
            },
            children: [
                {
                    type: 'EX_LOOKUP_FIELD',
                    props: {
                        label: 'Dashboard widget',
                        name: 'WidgetId',
                        size: 'large',
                        lookupName: 'DashboardTypeWidgets',
                        isLookupTypeFixed: true,
                        required: true,
                        searchScreenTitle: 'Dashboard Widget Lookup',
                        isDashboardTypeScoped: true,
                    }
                },
                {
                    id: 1,
                    type: 'SELECT_FIELD',
                    visible: true,
                    props: {
                        required: true,
                        label: 'Add to',
                        name: 'LayoutPanel',
                        placeholder: '',
                        size: 'medium',
                        apiPrefs: {
                            path: '/CustomTypes/Lookup/WidgetLayoutPanel/Search',
                            method: 'POST',
                            params: null
                        },
                    }
                },
            ]
        }
    ]
};
export default AddWidgetForm;
